// Un export mensile e' uno storico completo: deve conservare tutte le date del
// mese selezionato, comprese quelle precedenti al giorno in cui viene generato.
export const getMonthlyExportDates = (dateRange = []) =>
  [...dateRange]
    .filter(Boolean)
    .sort((a, b) => new Date(a) - new Date(b));
